import { QueryClient, useQuery } from "@tanstack/react-query"

export const queryClient = new QueryClient()

export function useCollectionsQuery({ params, collectionsURL, siteSelected, sendSiteId, fetch, autoRefresh = true }) {
  if (siteSelected && sendSiteId) {
    const { key, id } = siteSelected
    params = {
      ...params,
      [key]: id,
    }
  }

  return useQuery({
    staleTime: 1000 * 60 * 1,
    retry: 1,
    refetchInterval: autoRefresh && 1000 * 5 * 1,
    refetchOnWindowFocus: true,
    queryKey: [collectionsURL, JSON.stringify(params)],
    queryFn: async () => await fetch({
      url: collectionsURL,
      params,
    }),
  })
}
